import VideoSlideshowGridViewer from './VideoSlideshowGridViewer';

export default VideoSlideshowGridViewer;
